<template>
  <div class="site-wrapper">

    <router-view />

  </div>
</template>
<script>

export default {
  name: 'PrintLayout',
  components: {

  },
  data() {
    return {

    }
  }
}
</script>
<style lang='scss' scoped>
.site-wrapper {
  background-color: #efefef;
}
</style>
